import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { cookieService } from '@services/cookie.service';
import { User } from '@typings/user';
import { generateAnonymousUserId } from '@utils/index';

type InitialState = {
  user: User | null;
  isAnonymous: boolean;
  forgotPassword: { email: string | null };
};

const createAnonymousUser = (id?: string): User => {
  return {
    id: id || generateAnonymousUserId(),
    name: '',
    image: null,
    background: null,
    score: 0,
  };
};

export const initialState: InitialState = {
  user: null,
  isAnonymous: true,
  forgotPassword: { email: null },
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      if (!action.payload) {
        state.user = createAnonymousUser(
          state.isAnonymous ? state.user?.id : undefined,
        );
        state.isAnonymous = true;
      } else {
        const { token, ...user } = action.payload;
        if (token) {
          cookieService.setAuthToken(token);
        }

        state.user = { ...state.user, ...user };
        state.isAnonymous = false;
      }
    },
    setEmailVerified: (state, action: PayloadAction<boolean>) => {
      if (state.user) {
        state.user.emailVerified = action.payload;
      }
    },
    setForgotPasswordEmail: (state, action: PayloadAction<string | null>) => {
      state.forgotPassword.email = action.payload;
    },
  },
});

export const { setUser, setEmailVerified, setForgotPasswordEmail } =
  authSlice.actions;

export default authSlice.reducer;
